import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

import { SharedModule } from 'app/shared/shared.module';
import { UIComponentsModule } from 'app/ui-components/ui-components.module';

import { CompanyTemplatesModalComponent } from './company-library/company-templates-modal.component';
import { PublicTemplatesModalComponent } from './public-library/public-templates-modal.component';
import { SignUpTemplatesModalForComponent } from './sign-up/sign-up-templates-modal.component';
import { BusinessAttributesFacetComponent } from './templates-selector/business-attributes-facet/business-attributes-facet.component';
import { TemplatesSelectorToolBarComponent } from './templates-selector/templates-list-selection-toolbar/templates-selector-tool-bar.component';
import { TemplatesSelectorCardComponent } from './templates-selector/templates-selector-card/templates-selector-card.component';
import { TemplatesSelectorGridViewComponent } from './templates-selector/templates-selector-grid-view/templates-selector-grid-view.component';
import { TemplatesSelectorRegisterViewComponent } from './templates-selector/templates-selector-register-view/templates-selector-register-view.component';
import { TemplatesSelectorComponent } from './templates-selector/templates-selector.component';
import { TemplatesListModule } from '../templates-list/templates-list.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    RouterModule,
    TemplatesListModule,
    NgSelectModule,
    UIComponentsModule,
  ],
  declarations: [
    PublicTemplatesModalComponent,
    SignUpTemplatesModalForComponent,
    CompanyTemplatesModalComponent,
    TemplatesSelectorComponent,
    TemplatesSelectorRegisterViewComponent,
    TemplatesSelectorGridViewComponent,
    TemplatesSelectorToolBarComponent,
    TemplatesSelectorCardComponent,
    BusinessAttributesFacetComponent,
  ],
  exports: [TemplatesSelectorComponent],
})
export class TemplatesLibraryModule {}
